module.exports = __webpack_public_path__ + "img/786.fac7cacd.jpg";